<template>
    <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
        <div class="header2">
            <h1 class="title">
                <router-link to="/currentMedications">
                    Current Medications
                </router-link>
            </h1>
            <h1>|</h1>
            <h1 class="title">
                Medication Administration
            </h1>
            <span id="patientNote" class="coltext msgiconbtn"><img title="Write a note"
                src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
                width="40" height="40" @click="showNote(patient.id)" />
            </span>
        </div>
        <!-- <span class="dateRanger"> Date range: </span>
        <select v-model="range">
            <option v-for="dateRange in dateRanges" :value="dateRange.value" :key="dateRange.value">
                {{ dateRange.name }}
            </option>
        </select> -->
        <!-- <span class="dateGrouper"> Group dates: </span>
        <select v-model="selected">
            <option v-for="dateGroup in dateGroups" v-bind:value="{ id: dateGroup.value, text: dateGroup.name }"
                :key="dateGroup.name">
                {{ dateGroup.name }}
            </option>
        </select> -->
        <div class="gridcontainer">
            <measure-grid :selected = "this.selected" :grid="this.nebData" :isMedAdmin="true" :range="50000"/>
        </div>
        <note-popup ref="notePopup" :type="'9898X'" class="note__popup" :patient="patient" :id="'note__popup' + patient.id" style="display: none" />
    </div>
</template>

<script>
import MeasureGrid from '@/components/private-layouts/_partials/watch/MeasuresGrid'
import { CURR_API, OTHER_API } from '@/constants/apis'
import axios from 'axios'
import { mapGetters } from "vuex";
import NotePopup from "@/components/private-layouts/NotePopup.vue"
export default {
    name: "MedAdmin",
    components: {
        'measure-grid': MeasureGrid,
        'note-popup': NotePopup
    },
    data() {
        return {
            selected: null,
            dateGroups: [
                { name: 'every week', value: 7 },
                { name: 'every 2 weeks', value: 14 },
                { name: 'every 30 days', value: 30 },
                { name: 'every 90 days', value: 90 },
                { name: 'every 365 days', value: 365 },
                { name: 'all', value: 50000 }
            ],
            nebData: []
        }
    },
    mounted() {
        this.getNebData()
    },
    computed: {
        ...mapGetters("login", {
            allData: "getAllData",
        }),
        patient: function () {
            return this.allData.patient;
        },
    },
    methods: {
        async getNebData() {
            let content = {
                "GetPatientInfo": {
                    "API_Meth": "GetNebulizerData",
                    "pid": ("" + this.patient.externId).length == 7 ? "0" + this.patient.externId : "" + this.patient.externId,
                }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    this.nebData = res.data.reverse()
                }, error => {
                    alert("Error: Check the console log")
                    console.log(error)
                })
        },
        showNote(id){
            let note = document.getElementById('note__popup'+id)
            note.style.display = 'flex'
            this.$refs.notePopup.startTimer()
        }
    }
}

</script>
<style scoped lang="scss">
.header2 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    //   color: #0060ff;
}

.title {
    margin-right: 20px;
}
</style>